export function emptyStats() {
    return {
        fps: 0, frameMs: 0, frameMsMax: 0, simMs: 0, prepMs: 0, sortMs: 0, renderMs: 0, entities: 0, characters: 0,
        worldOnScreen: 0, visibleSprites: 0, floorTiles: 0, drawCalls: -1, sortPairs: 0, sortEdges: 0, textureMB: 0,
        resolution: 1, tier: '', renderer: '', lightPasses: 0, droppedSteps: 0,
    };
}
/**
 * Counts WebGL draw calls by wrapping the context's draw functions.
 * Debug only: the wrapper costs a function call per draw.
 */
export class DrawCallCounter {
    count = 0;
    supported;
    constructor(renderer) {
        const gl = renderer.gl;
        this.supported = !!gl;
        if (!gl)
            return;
        const self = this;
        for (const name of ['drawElements', 'drawArrays', 'drawElementsInstanced', 'drawArraysInstanced']) {
            const orig = gl[name];
            if (typeof orig !== 'function')
                continue;
            gl[name] = function (...args) {
                self.count++;
                return orig.apply(this, args);
            };
        }
    }
}
/** Small DOM overlay (cheaper than canvas text and never part of the world render). */
export class PerfOverlay {
    el;
    visible;
    constructor(parent, visible) {
        this.el = document.createElement('div');
        this.el.className = 'enugu-perf';
        Object.assign(this.el.style, {
            position: 'absolute',
            left: 'max(6px, env(safe-area-inset-left))',
            top: 'max(6px, env(safe-area-inset-top))',
            padding: '6px 8px',
            background: 'rgba(20,14,10,0.72)',
            color: '#f6e7c8',
            font: '11px/1.35 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
            whiteSpace: 'pre',
            pointerEvents: 'none',
            borderRadius: '6px',
            zIndex: '10',
        });
        this.visible = visible;
        this.el.style.display = visible ? 'block' : 'none';
        parent.appendChild(this.el);
    }
    toggle(force) {
        this.visible = force ?? !this.visible;
        this.el.style.display = this.visible ? 'block' : 'none';
    }
    get shown() {
        return this.visible;
    }
    update(s) {
        if (!this.visible)
            return;
        const f = (n, d = 1) => n.toFixed(d);
        this.el.textContent =
            `FPS ${f(s.fps, 0)}  frame ${f(s.frameMs)} ms (max ${f(s.frameMsMax)})\n` +
                `cpu: sim ${f(s.simMs, 2)}  prep ${f(s.prepMs, 2)}  sort ${f(s.sortMs, 2)}  pixi ${f(s.renderMs, 2)} ms\n` +
                `entities ${s.entities}  chars ${s.characters}  on-screen ${s.worldOnScreen}\n` +
                `sprites ${s.visibleSprites} (+${s.floorTiles} floor)  draws ${s.drawCalls < 0 ? 'n/a' : s.drawCalls}\n` +
                `sort pairs ${s.sortPairs} edges ${s.sortEdges}  light passes ${s.lightPasses}\n` +
                `tex ${f(s.textureMB)} MB  res ${f(s.resolution, 2)}  tier ${s.tier}  ${s.renderer}` +
                (s.droppedSteps ? `\ndropped sim steps ${s.droppedSteps}` : '');
    }
}
